import React from 'react'

const ThreeCardGrid = props => {
  return (
    
    <section className="g-py-100">
    <div className="container">
      <header className="g-mb-50">
        <div className="u-heading-v2-3--bottom g-brd-primary g-mb-20">
          <h2 className="h4 u-heading-v2__title g-color-gray-dark-v2 g-font-weight-600 text-uppercase">Our Recent Projects</h2>
        </div>
        <p className="g-font-size-16">Included Over 2000+ UI Components tvero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas moles.</p>
      </header>

      <div className="row">
        <div className="col-lg-4 col-md-6 g-mb-30 g-mb-0--lg">
          <article className="u-block-hover u-shadow-v21 rounded">
            <figure className="u-bg-overlay g-bg-black-opacity-0_4--after">
              <img className="img-fluid w-100 u-block-hover__main--zoom-v1" src="/img-temp/400x270/img17.jpg" alt="Image description" />
            </figure>

            <header className="u-bg-overlay__inner g-pos-abs g-top-30 g-right-30 g-left-30 g-color-white">
              <h3 className="h4">
                  <a className="g-color-white" href="#">Unify Template</a>
                </h3>
              <p>Consectetur adipiscing elitut eleifend nisl</p>
            </header>

            <ul className="list-inline u-bg-overlay__inner g-pos-abs g-bottom-10 g-left-30 g-opacity-0_8">
              <li className="list-inline-item">
                <div className="g-brd-around g-brd-2 g-brd-white rounded-circle">
                  <img className="g-width-30 g-height-30 rounded-circle" src="/img-temp/100x100/img12.jpg" alt="Image description" />
                </div>
              </li>
              <li className="list-inline-item g-ml-minus-20">
                <div className="g-brd-around g-brd-2 g-brd-white rounded-circle">
                  <img className="g-width-30 g-height-30 rounded-circle" src="/img-temp/100x100/img5.jpg" alt="Image description" />
                </div>
              </li>
              <li className="list-inline-item g-ml-minus-20">
                <div className="g-brd-around g-brd-2 g-brd-white rounded-circle">
                  <img className="g-width-30 g-height-30 rounded-circle" src="/img-temp/100x100/img7.jpg" alt="Image description" />
                </div>
              </li>
              <li className="list-inline-item g-font-weight-600 g-color-white">+21</li>
            </ul>
          </article>
        </div>

        <div className="col-lg-4 col-md-6 g-mb-30 g-mb-0--lg">
          <article className="u-block-hover u-shadow-v21 rounded">
            <figure className="u-bg-overlay g-bg-black-opacity-0_4--after">
              <img className="img-fluid w-100 u-block-hover__main--zoom-v1" src="/img-temp/400x270/img13.jpg" alt="Image description" />
            </figure>

            <header className="u-bg-overlay__inner g-pos-abs g-top-30 g-right-30 g-left-30 g-color-white">
              <h3 className="h4">
                  <a className="g-color-white" href="#">Htmlstream Freebies</a>
                </h3>
              <p>Consectetur adipiscing elitut eleifend nisl</p>
            </header>

            <ul className="list-inline u-bg-overlay__inner g-pos-abs g-bottom-10 g-left-30 g-opacity-0_8">
              <li className="list-inline-item">
                <div className="g-brd-around g-brd-2 g-brd-white rounded-circle">
                  <img className="g-width-30 g-height-30 rounded-circle" src="/img-temp/100x100/img7.jpg" alt="Image description" />
                </div>
              </li>
              <li className="list-inline-item g-ml-minus-20">
                <div className="g-brd-around g-brd-2 g-brd-white rounded-circle">
                  <img className="g-width-30 g-height-30 rounded-circle" src="/img-temp/100x100/img4.jpg" alt="Image description" />
                </div>
              </li>
              <li className="list-inline-item g-ml-minus-20">
                <div className="g-brd-around g-brd-2 g-brd-white rounded-circle">
                  <img className="g-width-30 g-height-30 rounded-circle" src="/img-temp/100x100/img5.jpg" alt="Image description" />
                </div>
              </li>
              <li className="list-inline-item g-font-weight-600 g-color-white">+42</li>
            </ul>
          </article>
        </div>

        <div className="col-lg-4 col-md-6">
          <article className="u-block-hover u-shadow-v21 rounded">
            <figure className="u-bg-overlay g-bg-black-opacity-0_4--after">
              <img className="img-fluid w-100 u-block-hover__main--zoom-v1" src="/img-temp/400x270/img3.jpg" alt="Image description" />
            </figure>

            <header className="u-bg-overlay__inner g-pos-abs g-top-30 g-right-30 g-left-30 g-color-white">
              <h3 className="h4">
                  <a className="g-color-white" href="#">Pixeel Ltd.</a>
                </h3>
              <p>Consectetur adipiscing elitut eleifend nisl</p>
            </header>

            <ul className="list-inline u-bg-overlay__inner g-pos-abs g-bottom-10 g-left-30 g-opacity-0_8">
              <li className="list-inline-item">
                <div className="g-brd-around g-brd-2 g-brd-white rounded-circle">
                  <img className="g-width-30 g-height-30 rounded-circle" src="/img-temp/100x100/img5.jpg" alt="Image description" />
                </div>
              </li>
              <li className="list-inline-item g-ml-minus-20">
                <div className="g-brd-around g-brd-2 g-brd-white rounded-circle">
                  <img className="g-width-30 g-height-30 rounded-circle" src="/img-temp/100x100/img7.jpg" alt="Image description" />
                </div>
              </li>
              <li className="list-inline-item g-ml-minus-20">
                <div className="g-brd-around g-brd-2 g-brd-white rounded-circle">
                  <img className="g-width-30 g-height-30 rounded-circle" src="/img-temp/100x100/img6.jpg" alt="Image description" />
                </div>
              </li>
              <li className="list-inline-item g-font-weight-600 g-color-white">+15</li>
            </ul>
          </article>
        </div>
      </div>
    </div>
  </section>

  )
}

export default ThreeCardGrid
